import React, { getGlobal } from "reactn";
import DialogTitle from "@material-ui/core/es/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/es/DialogContent/DialogContent";
import Dialog from "@material-ui/core/es/Dialog/Dialog";
import Spinner from "js/react/components/Spinner";
import { withStyles } from "@material-ui/core/styles";

const StyledSpinner = withStyles({
    spinnerAddOn: {
        marginTop: "20px"
    }
})(Spinner);

function LoadingDialog({ dialogProps, title, onAccept, classes }) {
    const isLoadingDialogOpen = getGlobal().isLoadingDialogOpen;

    return (
        <Dialog
            classes={classes}
            open={isLoadingDialogOpen || false}
            onClose={onAccept}
            {...dialogProps}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent className="dialog-content-text">
                <StyledSpinner />
            </DialogContent>
        </Dialog>
    );
}

const StyledLoadingDialog = withStyles({
    paper: {
        height: "150px"
    }
})(LoadingDialog);

export default StyledLoadingDialog;
